import { CommonResponseModel } from '@needle-management/shared-models';
import { Injectable } from '@nestjs/common';
import { NeedleSizesRepository } from './needle-sizes-repo';
import { NeedleSizesDTO } from './needle-sizes-dto';
import { NeedleSizes } from './needle-sizes-entity';

@Injectable()
export class NeedleSizesService {
    constructor(
        private needleSizesRepo: NeedleSizesRepository,
    ) { }


    async createNeedleSizes(req: NeedleSizesDTO): Promise<CommonResponseModel> {
        console.log(req);
        try {
            const existingNeedleSize = await this.needleSizesRepo.findOne({
                where: { needleSizes: req.needleSizes },
            });
            if (existingNeedleSize) { return new CommonResponseModel(false, 0, `Needle Size exists.`, []); }
            const entity = new NeedleSizes();
            entity.needleSizes = req.needleSizes;
            entity.isActive = req.isActive;
            entity.createdUser = req.createdUser;
            entity.updatedUser = req.updatedUser;
            entity.versionFlag = req.versionFlag;
            const save = await this.needleSizesRepo.save(entity);
            if (save) {
                return new CommonResponseModel(true, 1, 'Created successfully', save);
            } else {
                return new CommonResponseModel(false, 0, 'Something went wrong in Needle Sizes creation', []);
            }
        } catch (err) {
            console.error(err);
            return new CommonResponseModel(false, 0, 'An error occurred during creation', []);
        }
    }


    async getAllNeedleSizes(): Promise<CommonResponseModel> {
        const result = await this.needleSizesRepo.getAllNeedleSizesQuery()
        if (result.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', result);
        }
        return new CommonResponseModel(true, 1, 'No data found', []);
    }

    async getActiveNeedleSizes(): Promise<CommonResponseModel> {
        const data = await this.needleSizesRepo.find({ where: { isActive: true } });
        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
        }
        return new CommonResponseModel(true, 1, 'No active Needle Size data found', []);
    }

    async deleteNeedleSizes(req: NeedleSizes): Promise<CommonResponseModel> {
        try {
            const result = await this.needleSizesRepo.delete(
                { id: req.id },
            );

            if (result.affected > 0) {
                return new CommonResponseModel(true, 1, 'Deleted successfully', result);
            } else {
                return new CommonResponseModel(false, 0, 'Deleted failed', []);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async updateNeedleSizes(req: NeedleSizes): Promise<CommonResponseModel> {
        try {
            const result = await this.needleSizesRepo.update(
                { id: req.id },
                { needleSizes: req.needleSizes, updatedUser: req.updatedUser, isActive: req.isActive }
            );
            if (result.affected > 0) {
                return new CommonResponseModel(true, 1, 'Updated successfully', result);
            } else {
                return new CommonResponseModel(false, 0, 'Update failed', []);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivateNeedleSizes(req: NeedleSizes): Promise<CommonResponseModel> {
        try {
            const exists = await this.needleSizesRepo.findOne({ where: { id: req.id } });
            if (!exists) {
                throw new CommonResponseModel(false, 99998, 'No Needle Sizes found');
            }
            const update = await this.needleSizesRepo.update(
                { id: req.id },
                { isActive: req.isActive, updatedUser: req.updatedUser }
            );
            if (exists.isActive && !req.isActive) {
                if (update.affected) {
                    return new CommonResponseModel(true, 1, 'Needle Sizes deactivated successfully');
                } else {
                    throw new CommonResponseModel(false, 0, 'Needle Sizes already deactivated');
                }
            } else if (!exists.isActive && req.isActive) {
                if (update.affected) {
                    return new CommonResponseModel(true, 1, 'Needle Sizes  activated successfully');
                } else {
                    throw new CommonResponseModel(false, 0, 'Needle Sizes  already activated');
                }
            } else {
                return new CommonResponseModel(false, 0, 'No changes were made');
            }
        } catch (err) {
            return err;
        }
    }
}
